import { voucherStatusVariant } from "../../../../../../helpers/conts"


const StatusCell = ({ status }) => <span className={"text-capitalize badge badge-" + voucherStatusVariant[status]}>{status}</span>

export default StatusCell